import { useState } from "react";
import Navigation from "../components/Navigation";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { FosterMoods, FosterMoodLog } from "../http/server-apis";
import Loader from "../components/loaders/Loader";
import { useTranslation } from "react-i18next";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import { useNavigate } from "react-router-dom";

const Moods = () => {
  const { selectedLanguage, user } = useSelector((state) => state.Language);

  const [moods, setMoods] = useState([]);
  const [moodModal, setMoodModal] = useState("");
  const [openModal, setOpenModal] = useState(false);

  const navigate = useNavigate();

  const { t } = useTranslation();

  const { isLoading } = useQuery(
    ["get-all-languge"],
    () =>
      FosterMoods("get", {
        postfix: `?LangCode=${selectedLanguage}`,
      }),
    {
      onSuccess(data) {
        if (data.status === 200) {
          if (data.data.Status === "success") {
            setMoods(data.data.Mood);
          }
        }
      },
    }
  );

  const handleMood = async (mood) => {
    try {
      const response = await FosterMoodLog("post", {
        data: {
          StarsNumber: user,
          MoodID: mood.MoodID,
        },
      });
      if (response.data.Status === "success") {
        //Open Modal And Redirect to homepage
        setMoodModal(mood);
        setOpenModal(true);
      }
    } catch (error) {}
  };

  if (isLoading) {
    return (
      <>
        <Navigation title={"MOODS"} appBarColor="orange" />
        <div className="white-card ">
          <Loader />
        </div>
      </>
    );
  }

  return (
    <>
      <Navigation title={"MOODS"} appBarColor="orange" />
      <div className="language-card">
        <h1 className="text-center my-3">{t("HOW_ARE_YOU_FEELING_TODAY")}</h1>

        <div className="grid grid-cols-2 gap-3 mx-auto  ">
          {moods.map((mood) => (
            <div
              key={mood.MoodID}
              className="border border-1 rounded-md flex justify-center py-2"
              onClick={() => handleMood(mood)}
            >
              <div>
                <img
                  src={mood.Icon}
                  alt={mood.Icon}
                  className="mx-auto w-[30%] mb-1"
                />
                <p className="text-center">{mood.Moods}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Dialog
        open={openModal}
        onClose={() => setOpenModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div className="pt-3">
          <img
            src={moodModal.Icon}
            alt={moodModal.Icon}
            className="mx-auto w-[20%]"
          />
          <p className="text-xs my-2 text-center text-default font-normal">
            Thanks for Adding your mood
          </p>
        </div>
        <DialogActions className="flex modal-justify-center">
          <button
            className="bg-primary w-[42%] uppercase text-xs mb-1 px-12 text-white py-2 shadow shadow-slate-400 rounded-sm"
            onClick={() => {
              setOpenModal(false);
              navigate("/home");
            }}
          >
            Next
          </button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Moods;
